import React from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { ONLINE_ADMISSION_URL } from "../../data/externalLinks";

function Applyonline() {
  const contacts = {
    title: "Benadir University",
    address: "Wadada Jaamacadda Benadir,",
    street: "Behind saybiayno Hodan",
    city: "Mogadishu - Somalia",
    tell: "Admission Help Line: +2018",
    email: "admission@bu.edu.so",
  };

  return (
    <div className="relative xl:pt-[95px] md:pt-[95px] sm:pt-[95px] xs:pt-[75px] flex items-center justify-center overflow-hidden rounded-lg bg-gradient-to-r from-[#0863AA] to-indigo-800 p-6 shadow-2xl min-h-[520px]">
      <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-white/10"></div>
      <div className="absolute -bottom-8 -left-8 h-24 w-24 rounded-full bg-white/10"></div>

      <div className="relative z-10 text-center max-w-3xl w-full px-4">
        <div className="flex justify-center mb-6">
          <AiFillFileAdd className="text-white text-8xl md:text-7xl" />
        </div>

        <h1 className="mb-4 text-3xl font-bold text-white md:text-4xl">
          Online Admission
        </h1>

        <p className="mb-8 text-lg text-white/90 md:text-xl">
          Apply for undergraduate or postgraduate programs online, upload your
          documents, and track your application status until approval.
        </p>

        <a
          href={ONLINE_ADMISSION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-[#0863AA] font-semibold text-xl px-10 py-4 rounded-lg shadow-lg hover:bg-[#f0f7fc] transition-colors"
        >
          Go to Admission Portal
        </a>

        <div className="text-[#0863AA] bg-white border-2 border-[#0863AA] rounded-xl py-8 px-8 flex flex-col justify-center items-center space-y-2 mt-10">
          <p className="text-xl font-semibold xs:text-base">Need help?</p>
          <p className="py-1 text-lg xs:text-base">{contacts.title}</p>
          <p className="py-1 text-lg xs:text-base">{contacts.address}</p>
          <p className="py-1 text-lg xs:text-base">{contacts.street}</p>
          <p className="py-1 text-lg xs:text-base">{contacts.city}</p>
          <p className="py-1 text-lg xs:text-base">{contacts.tell}</p>
          <a
            href={`mailto:${contacts.email}`}
            className="py-1 text-lg xs:text-base text-[#0863AA] underline"
          >
            {contacts.email}
          </a>
        </div>
      </div>

      <div className="absolute top-0 left-0 h-12 w-12 border-l-2 border-t-2 border-yellow-400"></div>
      <div className="absolute bottom-0 right-0 h-12 w-12 border-r-2 border-b-2 border-yellow-400"></div>
    </div>
  );
}

export default Applyonline;
